import React, { FC } from 'react'
import { createStyles, makeStyles, ChipProps, Box, Chip, Avatar } from '@material-ui/core'

export interface TChipData {
    id: string;
    label: string;
    avatar?: string;
}

export interface SelectableChipsListProps extends Pick<ChipProps, 'color' | 'size'> {
    list: TChipData[];
    selectedItems: TChipData[];
    onSelect: (item: TChipData) => void;
}

const SelectableChipsList: FC<SelectableChipsListProps> = (props) => {

    const classes = useStyles();
    const { list = [], onSelect, selectedItems = [], children, ...chipProps } = props;

    return (
        <Box className={classes.root} >
            {
                list.map((item, i) => {
                    const isSelected = selectedItems.findIndex(x => x.id === item.id) !== -1;
                    return (
                        <Box key={i} mr={0.5} mb={0.5} >
                            <Chip
                                variant={isSelected ? 'default' : 'outlined'}
                                {...chipProps}
                                label={item.label}
                                onClick={() => onSelect?.(item)}
                                avatar={item.avatar ? <Avatar src={item.avatar} /> : undefined}
                            />
                        </Box>
                    )
                })
            }
        </Box>
    )
}

const useStyles = makeStyles((theme) => {
    return (createStyles({
        root: {
            display: 'flex',
            flexWrap: 'wrap'
        }
    }))
})

export default SelectableChipsList